import React from 'react';
import McpTokenManager from '../../McpTokenManager';

interface Props {
  authToken: string;
}

const McpSection: React.FC<Props> = ({ authToken }) => (
  <McpTokenManager authToken={authToken} />
);

export default McpSection;
